/**
 * Created by Mikhail Menshenin on 2/29/24
 */

const MedalCollectionWindow = CleverappsWindow.extend({
    onWindowLoaded: function (game) {
        const styles = cleverapps.styles.MedalCollectionWindow;

        this.game = game;

        this.game.on("unlocked", this.showUnlocked.bind(this), this);

        this._super({
            title: Messages.get("MedalCollectionWindow.Title"),
            name: "MedalCollectionWindow",
            content: this.createContent(styles),
            styles,
            noPadding: true,
            foreground: bundles.windows.frames.window_foreground_png,
            help: function () {
                cleverapps.focusManager.display({
                    focus: "MedalCollectionHelp",
                    stack: true,
                    action: function (f) {
                        new GuideWindow({
                            name: "MedalCollectionGuideWindow",
                            bundle: bundles.medalcollectionguidewindow
                        });
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }
        });

        this.tabs.onTabChanged = this.onTabChanged.bind(this);

        this.tabs.activateTab("merge");

        if (cleverapps.config.debugMode) {
            cleverapps.UI.onClick(this.windowTitle, () => {
                this.game.addMore(1);
            });
        }
    },

    createContent: function (styles) {
        const content = this.content = new cc.Node();
        content.setContentSize2(styles);

        const tabs = this.tabs = new Tabs(this.createTabs(), styles.tabs);
        tabs.setAlignment(styles.tabs);
        content.addChild(tabs);

        return content;
    },

    createTabs: function () {
        return {
            merge: {
                icon: bundles.medalcollection.frames.tab_icon_merge_png,
                generator: this.createTab.bind(this, MedalMergeTabView)
            },
            library: {
                icon: bundles.medalcollection.frames.tab_icon_collection_png,
                generator: this.createTab.bind(this, MedalLibraryTabView)
            }
        };
    },

    createTab: function (TabView) {
        const tab = new TabView(this.game);
        tab.setAlignment({ x: { align: "center" }, y: { align: "top" } });
        this.content.addChild(tab);
        return tab;
    },

    showUnlocked: function (level) {
        cleverapps.focusManager.display({
            focus: "MedalUnlocked",
            stack: true,
            action: function (f) {
                new MedalUnlockedWindow(level);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    },

    onTabChanged: function (tabId) {
        this.foreground.setVisible(tabId === "library");
    },

    listBundles: function () {
        return ["medalcollection"];
    }
});

cleverapps.styles.MedalCollectionWindow = {
    width: 832,
    height: 1216,

    tabs: {
        direction: cleverapps.UI.VERTICAL,
        margin: -20,
        width: 130,
        height: 160,

        x: { align: "left", dx: -120 },
        y: { align: "top", dy: -140 }
    },

    helpButton: {
        x: { align: "left", dx: 20 },
        y: { align: "center", dy: 2 }
    }
};
